import { Route, Routes } from "react-router-dom";
import PublicTicketForm from "./pages/PublicTicketForm";
import IntakeFormPage from "./pages/IntakeFormPage";
import CsatPage from "./pages/CsatPage";

export default function PublicApp() {
  return (
    <Routes>
      <Route path="/ticket/nieuw" element={<PublicTicketForm />} />
      <Route path="/form/:slug" element={<IntakeFormPage />} />
      <Route path="/form/:slug/:lang" element={<IntakeFormPage />} />
      <Route path="/csat/:ticketId" element={<CsatPage />} />
      <Route path="*" element={<div className="public-shell">Pagina niet gevonden.</div>} />
    </Routes>
  );
}
